/** @jsx jsx */
import { jsx } from '@emotion/core';
// import React from 'react';
import { Container, Row, Column } from '../../../styles/Grid';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import { CLOUDINARY_BASE_VALUES } from '../../../utils/constants';
import { Breakpoints } from '../../../styles/Grid/GridSizes';
import DotComponent from '../../ui/DotComponent';
import Spacer from '../../ui/Spacer';
import { Icon } from '../../ui/Icon';
import * as styles from './index.styles';

import InputForm from './InputForm';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { get } from 'lodash';

import Picture from '../../ui/Picture';

const LeftImageSizes = {
  [Breakpoints.xs]: {
    ...CLOUDINARY_BASE_VALUES,
  },
  [Breakpoints.sm]: {
    ...CLOUDINARY_BASE_VALUES,
  },
  [Breakpoints.md]: {
    ...CLOUDINARY_BASE_VALUES,
  },
  [Breakpoints.lg]: {
    ...CLOUDINARY_BASE_VALUES,
  },
  [Breakpoints.xl]: {
    ...CLOUDINARY_BASE_VALUES,
  },
};

const LeftImageForSmallerDevicesSizes = {
  ...CLOUDINARY_BASE_VALUES,
  [Breakpoints.xs]: {
    ...CLOUDINARY_BASE_VALUES,
  },
  [Breakpoints.sm]: {
    ...CLOUDINARY_BASE_VALUES,
  },
  [Breakpoints.md]: {
    ...CLOUDINARY_BASE_VALUES,
  },
  [Breakpoints.lg]: {
    ...CLOUDINARY_BASE_VALUES,
  },
  [Breakpoints.xl]: {
    ...CLOUDINARY_BASE_VALUES,
  },
};
class TalkToUs extends SafePureComponent {
  state = {
    isDedicatedPage: false,
  };
  renderForm = () => {
    const { fields } = this.props;

    const PhoneNumberWatermark = get(
      fields,
      'PhoneNumberWatermark.value',
      'PhoneNumberWatermark',
    );
    const YourNameWatermark = get(
      fields,
      'YourNameWatermark.value',
      'YourNameWatermark',
    );
    const CTAText = get(fields, 'CTAText.value', 'Submit');

    const PhoneNumberOptions = get(fields, 'PhoneNumberOptions', []);
    const defaultPhoneValue = get(fields, 'DomainCountryISOCode2.value', '');

    const PhoneNumberParameterName = get(
      fields,
      'PhoneNumberParameterName.value',
      '',
    );
    const NameParameterName = get(fields, 'NameParameterName.value', '');
    const SubmissionAPIURL = get(fields, 'SubmissionAPIURL.value', '');
    const SuccessMessage = get(fields, 'SuccessMessage.value', '');
    const ErrorMessage = get(fields, 'ErrorMessage.value', '');
    const PhoneNumberRequiredErrorMessage = get(
      fields,
      'PhoneNumberRequiredErrorMessage.value',
      '',
    );
    const PhoneNumberInvalidErrorMessage = get(
      fields,
      'PhoneNumberInvalidErrorMessage.value',
      '',
    );

    return (
      <InputForm
        fields={fields}
        PhoneNumberWatermark={PhoneNumberWatermark}
        YourNameWatermark={YourNameWatermark}
        CTAText={CTAText}
        PhoneNumberOptions={PhoneNumberOptions}
        defaultPhoneValue={defaultPhoneValue}
        PhoneNumberParameterName={PhoneNumberParameterName}
        NameParameterName={NameParameterName}
        SubmissionAPIURL={SubmissionAPIURL}
        SuccessMessage={SuccessMessage}
        ErrorMessage={ErrorMessage}
        PhoneNumberRequiredErrorMessage={PhoneNumberRequiredErrorMessage}
        PhoneNumberInvalidErrorMessage={PhoneNumberInvalidErrorMessage}
      />
    );
  };

  goBack = () => {
    if (window.history.length === 1) {
      window.location = window.location.origin;
    } else {
      window.history.back();
    }
  };

  componentDidMount = () => {
    this.setState({ isDedicatedPage: this.isDedicatedPage() });
  };

  isDedicatedPage = () => {
    const getAllSection = document.querySelectorAll('section');

    return getAllSection && getAllSection.length === 1;
  };

  safeRender() {
    const { fields } = this.props;
    const { isDedicatedPage } = this.state;

    return (
      <Spacer customCss={styles.talktouscontentsholder}>
        <Container>
          <Row>
            <Column cols={{ sm: 6, md: 5, lg: 5, xl: 5 }}>
              {isDedicatedPage && (
                <div css={[styles.goBackButtonContainer]}>
                  <button css={styles.goBackButton} onClick={this.goBack}>
                    <Icon name="arrow-left" />
                    <span css={styles.goBackButtonLabel}>Back</span>
                  </button>
                </div>
              )}
              <div className="backbutton">
                <div>
                  {isDedicatedPage ? (
                    <h1>
                      {fields.Title.value}
                      <DotComponent />
                    </h1>
                  ) : (
                    <h2>
                      {fields.Title.value}
                      <DotComponent />
                    </h2>
                  )}
                </div>
              </div>
            </Column>
          </Row>

          <Row className={!isDedicatedPage && 'bottom_line'}>
            <Column
              className="leftside_sec"
              cols={{ sm: 6, md: 3, lg: 5, xl: 5 }}
            >
              <div className="leftsidearea">
                <div className="left_side">
                  <Picture
                    pictureCss={styles.img_desktop}
                    image={fields.LeftImage}
                    imageSizes={LeftImageSizes}
                    instantLoad
                    imageClassName="img_1"
                  />
                  {/* <img
                    className="img_1"
                    src={fields.LeftImage.value.src}
                    alt={fields.Title.value}
                  /> */}
                  <Picture
                    pictureCss={styles.img_tablet}
                    image={fields.LeftImageForSmallerDevices}
                    imageSizes={LeftImageForSmallerDevicesSizes}
                    imageClassName="img_2"
                    instantLoad
                  />
                </div>
                <div className="needtotalktxt">
                  <h3>{fields.LeftHeading.value}</h3>
                  <p>{fields.LeftIntro.value}</p>

                  <div className="callno">
                    <a href={'tel:' + fields.LeftPhoneNumber.value.trim()}>
                      <span>
                        <Icon name="contact" className="phone-default-icon" />
                      </span>
                      <span className="numb">
                        {fields.LeftPhoneNumber.value}
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </Column>
            <Column className="hrlinesec" cols={{ sm: 6, md: 1, xl: 1 }}>
              <div className="hrline"></div>
            </Column>
            <Column className="formarea" cols={{ sm: 6, md: 4, lg: 5 }}>
              <div className="formtxt">
                <h3>{fields.RightHeading.value}</h3>
                <p>{fields.RightIntro.value}</p>
              </div>

              {this.renderForm()}

              <div className="privacypolicytxt">
                <RichText
                  className="agreetxt"
                  field={fields.PrivacyPolicyText}
                  tag="span"
                />
              </div>
            </Column>
          </Row>
        </Container>
      </Spacer>
    );
  }
}

TalkToUs.displayName = 'TalkToUs';

export default TalkToUs;
